export const en = {
    'date-placeholder': 'dd.mm.yyyy',
    'number-set-placeholder': 'value, other value, ...',
    'your-value': 'your value'
};
